import { lazy, Suspense } from 'react';

import SuspenseLoader from 'src/components/SuspenseLoader';

const Loader = (Component) => (props) =>
  (
    <Suspense fallback={<SuspenseLoader />}>
      <Component {...props} />
    </Suspense>
  );

const ProductionOrderSummary = Loader(
  lazy(() => import('src/content/reports/ProductionOrderSummary'))
);

const InventoryTransaction = Loader(
  lazy(() => import('src/content/reports/InventoryTransaction'))
);

const InventoryTransactionSummary = Loader(
  lazy(() => import('src/content/reports/InventoryTransactionSummary'))
);

const QrcodesReport = Loader(
  lazy(() => import('src/content/reports/QrcodesReport'))
);

const DeviceIssueListing = Loader(
  lazy(() => import('src/content/reports/DeviceIssueListing/View'))
);

const DeviceAlerts = Loader(
  lazy(() => import('src/content/reports/DeviceAlerts/View'))
);

const POReport = Loader(
  lazy(() => import('src/content/reports/POReport'))
);

const PDISummary = Loader(
  lazy(() => import('src/content/reports/PDISummary/View'))
);

const PDIDetails = Loader(
  lazy(() => import('src/content/reports/PDISummary/Details'))
);

const ProcessLogSummary = Loader(
  lazy(() => import('src/content/reports/ProcessLogSummary/View'))
);

const ProcessLogOrderSummary = Loader(
  lazy(() => import('src/content/reports/ProcessLogOrderSummary/View'))
);

const StationDashboard = Loader(
  lazy(() => import('src/content/reports/SessionReport/StationDashboard'))
);

const JobWiseReport = Loader(
  lazy(() => import('src/content/reports/SessionReport/JobWiseReport'))
);

const UserWiseReport = Loader(
  lazy(() => import('src/content/reports/SessionReport/UserWiseReport'))
);

const reportRoutes = [
  {
    path: '/session-report/station-dashboard',
    element: <StationDashboard />
  },
  {
    path: '/session-report/job-wise',
    element: <JobWiseReport />
  },
  {
    path: '/session-report/job-wise-report',
    element: <JobWiseReport />
  },
  {
    path: '/job-wise-report',
    element: <JobWiseReport />
  },
  {
    path: '/session-report/user-wise',
    element: <UserWiseReport />
  },
  {
    path: '/session-report/user-wise-report',
    element: <UserWiseReport />
  },
  {
    path: '/user-wise-report',
    element: <UserWiseReport />
  },
  {
    path: '/session-report',
    element: <StationDashboard />
  },
  {
    path: '/station-dashboard',
    element: <StationDashboard />
  },
  {
    path: '/pdi-summary',
    element: <PDISummary />
  },
  {
    path: '/pdi-summary/pdi-details',
    element: <PDIDetails />
  },
  {
    path: '/po-report',
    element: <POReport />
  },
  {
    path: '/production-order-summary',
    element: <ProductionOrderSummary />
  },
  {
    path: '/inventory-transaction',
    element: <InventoryTransaction />
  },
  {
    path: '/inventory-transaction-summary',
    element: <InventoryTransactionSummary />
  },
  {
    path: '/qrcodes-report',
    element: <QrcodesReport />
  },
  {
    path: '/device-issue',
    element: <DeviceIssueListing />
  },
  {
    path: '/device-alert',
    element: <DeviceAlerts />
  },
  {
    path: '/process-log-summary',
    element: <ProcessLogSummary />
  },
  {
    path: '/process-log-order-summary',
    element: <ProcessLogOrderSummary />
  }
];

export default reportRoutes;
